import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { BookerRecall } from './../types/booker-recall.type';

@Component({
  selector: 'jb-book-recall-container',
  templateUrl: './book-recall.component.html',
  styleUrls: ['./book-recall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookRecallComponent implements OnInit {
  response: BookerRecall;
  firstResponseTitle: string;
  secondResponseTitle: string;
  bgUrl: string;

  ngOnInit() {
    if (this.response.title) {
      this.firstResponseTitle = this.response.title;
    }
  }
}

export const bookRecallResolver = (registry, data) => ({
  response: data.bookRecall[0] || { title: '', image: [], link: [] },
});
